import { createDefaultPageData } from 'types/rest/IPageData';
import { ISigningAppointmentSearchRequest } from 'types/signingAppointment/ISigningAppointmentSearchRequest';
import { ISigningAppointmentDashboardResponse } from 'types/signingAppointment/ISigningAppointmentDashboardResponse';
import { useListPagedSigningAppointmentsSearchQuery } from 'API/order/signingAppointment/SigningAppointmentAPI';
import { useGetImportantDays } from '../../hooks/useGetImportantDays';

const useDetermineCounterForGleamTitle = (filterParams: ISigningAppointmentSearchRequest) => {
  const { today, tomorrow, dayAfterTomorrow, endWeek, startWeek } = useGetImportantDays();

  const { data: todayData = createDefaultPageData<ISigningAppointmentDashboardResponse>() } =
    useListPagedSigningAppointmentsSearchQuery({
      ...filterParams,
      startDate: today,
      endDate: tomorrow,
      pageNumber: 0,
      pageSize: 1,
    });

  const { data: tomorrowData = createDefaultPageData<ISigningAppointmentDashboardResponse>() } =
    useListPagedSigningAppointmentsSearchQuery({
      ...filterParams,
      startDate: tomorrow,
      endDate: dayAfterTomorrow,
      pageNumber: 0,
      pageSize: 1,
    });

  const { data: thisWeekData = createDefaultPageData<ISigningAppointmentDashboardResponse>() } =
    useListPagedSigningAppointmentsSearchQuery({
      ...filterParams,
      startDate: startWeek,
      endDate: endWeek,
      pageNumber: 0,
      pageSize: 1,
    });

  const { data: pastDueData = createDefaultPageData<ISigningAppointmentDashboardResponse>() } =
    useListPagedSigningAppointmentsSearchQuery({
      ...filterParams,
      startDate: undefined,
      endDate: today,
      pageNumber: 0,
      pageSize: 1,
    });
  return {
    todayCount: todayData.totalElements,
    tomorrowCount: tomorrowData.totalElements,
    weekCount: thisWeekData.totalElements,
    pastDueCount: pastDueData.totalElements,
  };
};

export default useDetermineCounterForGleamTitle;
